import { render, staticRenderFns } from "./booking.vue?vue&type=template&id=c212412c&"
import script from "./booking.vue?vue&type=script&lang=js&"
export * from "./booking.vue?vue&type=script&lang=js&"
import style0 from "./booking.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports